import { LocalizationSpec } from "src/i18n/localizationSpec";
import en from "src/i18n/en";

type NestedStringObject = { [key: string]: string | NestedStringObject }

function mapKeysToKeyPath<T extends NestedStringObject>(structure: T, prefix = ""): T {
  type Type = { [key in keyof T]: string | NestedStringObject }
  const keys: (keyof T)[] = Object.keys(structure);
  return keys.reduce<Type>((obj, key) => {
    if(typeof structure[key] == "object") {
      obj[key] = mapKeysToKeyPath(structure[key] as NestedStringObject, `${prefix}${key as string}.`);
    } else {
      obj[key] = `${prefix}${key as string}`
    }
    return obj;
  }, {} as Type) as T
}

export default mapKeysToKeyPath<LocalizationSpec>(en)